AplicantRouting.$inject = ["$urlRouterProvider", "$stateProvider"];

function AplicantRouting($urlRouterProvider, $stateProvider) {

    $urlRouterProvider.otherwise("/Aplicant/BazarGetWay");

    $stateProvider

        .state('Aplicant', {

            abstract: true,

            url: '/Aplicant',

            template: '<ui-view id="Aplicant"></ui-view>'

        })

        .state('Aplicant.BazarGetWay', {

            url: '/BazarGetWay',

            controller: 'Aplicant.BazarGetWayController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./BazarGetWay/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./BazarGetWay/BazarGetWay.module');

                        $ocLazyLoad.load({

                            name: 'BazarGetWayModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "لیست خدمات",
                icon: "fas fa-list"
            },

        })
        .state('Aplicant.RequestList', {

            url: '/RequestList',

            controller: 'Aplicant.RequestListController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./RequestList/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./RequestList/RequestList.module');

                        $ocLazyLoad.load({

                            name: 'RequestListModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "درخواست های خدمت",
                icon: "fas fa-tasks"
            },

        })
        .state('Aplicant.FinalizedServices', {

            url: '/FinalizedServices',

            controller: 'Aplicant.FinalizedServicesController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./FinalizedServices/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./FinalizedServices/FinalizedServices.module');

                        $ocLazyLoad.load({

                            name: 'FinalizedServicesModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "لیست خدمات تعیین وضعیت شده",
                icon: "fas fa-tasks"
            },

        })
        .state('Aplicant.ShowDetails', {

            url: '/ShowDetails/:Id',

            controller: 'Aplicant.ShowDetailsController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./ShowDetails/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./ShowDetails/ShowDetails.module');

                        $ocLazyLoad.load({

                            name: 'ShowDetailsModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                parent: "Aplicant.RequestList",
                title: "جزئیات",
                icon: "fas fa-info-circle"
            },

        })
        .state('Aplicant.ServiceFinalization', {

            url: '/ServiceFinalization/:requestId',

            controller: 'Aplicant.ServiceFinalizationController',

            controllerAs: 'self',

            templateProvider: ['$q', ($q) => {

                return $q((resolve) => {

                    require.ensure([], () => {

                        let template = require('./ServiceFinalization/views/index.html');

                        resolve(template);

                    });

                });

            }],

            resolve: {

                Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

                    let deferred = $q.defer();

                    require.ensure([], function () {

                        let module = require('./ServiceFinalization/ServiceFinalization.module');

                        $ocLazyLoad.load({

                            name: 'ServiceFinalizationModule',

                        });

                        deferred.resolve(module);

                    });

                    return deferred.promise;

                }]

            },
            breadcrumbData: {
                title: "لیست خدمات تعیین وضعیت شده",
                icon: "fas fa-tasks"
            },

	})
  .state('Aplicant.ShowServises',{

  url: '/ShowServises',

  controller: 'Aplicant.ShowServisesController',

  controllerAs: 'self',

  templateProvider: ['$q', ($q) => {

      return $q((resolve) => {

          require.ensure([], () => {

              let template = require('./ShowServises/views/index.html');

              resolve(template);

          });

      });

  }],

  resolve: {

      Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

        let deferred = $q.defer();

        require.ensure([], function () {

            let module = require('./ShowServises/ShowServises.module');

            $ocLazyLoad.load({

                name: 'ShowServisesModule',

            });

            deferred.resolve(module);

        });

        return deferred.promise;

      }]

  }

	})
  .state('Aplicant.DetailsOfServices',{

  url: '/DetailsOfServices/:serviseId',

  controller: 'Aplicant.DetailsOfServicesController',

  controllerAs: 'self',

  templateProvider: ['$q', ($q) => {

      return $q((resolve) => {

          require.ensure([], () => {

              let template = require('./DetailsOfServices/views/index.html');

              resolve(template);

          });

      });

  }],

  resolve: {

      Lazyload: ['$q', '$ocLazyLoad', ($q, $ocLazyLoad) => {

        let deferred = $q.defer();

        require.ensure([], function () {

            let module = require('./DetailsOfServices/DetailsOfServices.module');

            $ocLazyLoad.load({

                name: 'DetailsOfServicesModule',

            });

            deferred.resolve(module);

        });

        return deferred.promise;

      }]

  }

    })/*endOfResolve*/ ;

}



export default AplicantRouting;
